import { User } from '../models/user'
import { Observable, Subject } from 'rxjs'
import { UserService } from './user.service'

export interface UserContext {
  readonly user$: Observable<User>
  readonly user: User
  readonly userUpdated$: Observable<void>
  readonly isUserFetchedAtLeastOnce: boolean
  readonly isUserFetchedAtLeastOnce$: Observable<boolean>
}

export interface UserContextNotifier {
  notify(user: User): void
  fetchUserAndNotify(): Promise<void>
}

export class UserContextImpl implements UserContext, UserContextNotifier {
  private _isUserFetchedAtLeastOnce$ = new Subject<boolean>()
  private _isUserFetchedAtLeastOnce = false

  private _user$ = new Subject<User>()
  private _user: User = User.asNotSignedIn()

  private _userUpdated$ = new Subject<void>()

  public get isUserFetchedAtLeastOnce$(): Observable<boolean> {
    return this._isUserFetchedAtLeastOnce$.asObservable()
  }

  public get isUserFetchedAtLeastOnce(): boolean {
    return this._isUserFetchedAtLeastOnce
  }

  public get user(): User {
    return this._user
  }

  public get user$(): Observable<User> {
    return this._user$.asObservable()
  }

  public get userUpdated$(): Observable<void> {
    return this._userUpdated$.asObservable()
  }

  public constructor(private readonly userService: UserService) {}

  public notify(user: User): void {
    this._user = user
    this._isUserFetchedAtLeastOnce = true

    this._user$.next(user)
    this._userUpdated$.next()
    this._isUserFetchedAtLeastOnce$.next(true)
  }

  public async fetchUserAndNotify(): Promise<void> {
    const user = await this.userService.getUser()
    this.notify(user)
  }
}
